import { createApp } from 'vue'
import * as ElementPlusIcons from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import { RecycleScroller, DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'


import router, { setupDynamicRoutes }  from '@/router/index'
// import '@/assets/theme.scss'  // 全局引入主题变量

import App from './App.vue'

let app: ReturnType<typeof createApp> | null = null

async function initApp() {
  // 如果已有应用实例，先卸载
  if (app) {
    app.unmount()
    app = null
  }

  // 等待动态路由设置完成
  const finalRoutes = await setupDynamicRoutes()
  
  // 创建新的应用实例
  app = createApp(App)
  
  app.provide('routes', finalRoutes)
  app.component('RecycleScroller', RecycleScroller)
  app.component('DynamicScroller', DynamicScroller)
  app.component('DynamicScrollerItem', DynamicScrollerItem)
  app.use(router)
  app.mount('#app')
  // 全局注册所有图标
  Object.keys(ElementPlusIcons).forEach(key => {
    app!.component(key, (ElementPlusIcons as any)[key])
  })
  
  return finalRoutes
}

// 导出重新初始化函数
export async function reinitializeApp() {
  try {
    await initApp()
    return true
  } catch (error) {
    console.error('重新初始化应用失败:', error)
    return false
  }
}

// 初始启动
initApp()